import { motion } from 'framer-motion'
import React, { useContext } from 'react'
import { StarterContext } from '../../../store/Starter'
function List({element,i}) {
    const { todoDelete } = useContext(StarterContext)
    const todoliststyle = {
        hidden: { x: "-100vw" },
        show: { x: 0 }
    }
    return (
        <>
            <li>
                <motion.div
                    variants={todoliststyle}
                    initial="hidden"
                    animate="show"
                    transition={{ duration: 0.5, type: "spring" }}
                    className="z-depth-1" id={i}
                    style={{ padding: "1rem", marginBottom: "1rem" }}>
                    {element}
                    <div className="right">
                        <i className="material-icons blue white-text" style={{marginRight:"0.4rem",padding:"0.2rem"}}>edit</i>
                        <i className="material-icons red white-text" onClick={()=>todoDelete(i)} style={{ marginRight: "0.4rem", padding: "0.2rem" }}>remove</i>
                    </div>
                </motion.div>
            </li>
        </>
    )
}

export default List
